<template>
  <div class="coming-soon">
    <div class="coming-soon__card">
      <div class="coming-soon__illustration">
        <span class="coming-soon__ring coming-soon__ring--outer"></span>
        <span class="coming-soon__ring coming-soon__ring--inner"></span>
        <div class="coming-soon__icon-wrap">
          <i class="pi pi-compass"></i>
        </div>
      </div>

      <h1 class="coming-soon__title">قريبًا</h1>
      <p class="coming-soon__subtitle">هذه الميزة قيد التطوير وستكون متاحة قريبًا.</p>
      <p class="coming-soon__description">نعمل حاليًا على تطوير هذه الصفحة لتقديم أفضل تجربة ممكنة.</p>

      <button type="button" class="ds-btn ds-btn--primary ds-btn--lg coming-soon__btn" @click="goBack">
        <i class="pi pi-arrow-right"></i>
        العودة
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonPage',
  methods: {
    goBack() {
      if (window.history.state && window.history.state.back) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },
  },
};
</script>

<style scoped>
.coming-soon {
  min-height: calc(100vh - var(--navbar-height, 60px));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
  background: var(--surface-ground);
}

.coming-soon__card {
  width: 100%;
  max-width: 30rem;
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--radius-2xl, 28px);
  box-shadow: var(--shadow-lg);
  padding: 3rem 2rem 2.5rem;
  text-align: center;
}

.coming-soon__illustration {
  position: relative;
  width: 8.5rem;
  height: 8.5rem;
  margin: 0 auto 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.coming-soon__ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1.5px dashed rgba(var(--gold-rgb), 0.45);
  animation: coming-soon-spin 18s linear infinite;
}

.coming-soon__ring--inner {
  inset: 0.9rem;
  border-style: solid;
  border-color: rgba(var(--primary-rgb), 0.12);
  animation-duration: 12s;
  animation-direction: reverse;
}

.coming-soon__icon-wrap {
  position: relative;
  width: 5.5rem;
  height: 5.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  box-shadow: var(--shadow-primary);
}

.coming-soon__icon-wrap .pi {
  font-size: 2.25rem;
  color: var(--gold);
}

.coming-soon__title {
  font-size: 1.875rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 0.625rem;
}

.coming-soon__subtitle {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  opacity: 0.85;
  margin: 0 0 0.5rem;
}

.coming-soon__description {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0 0 2rem;
  line-height: 1.7;
}

.coming-soon__btn {
  margin: 0 auto;
}

@keyframes coming-soon-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
